<mat-checkbox [color]="color" [(ngModel)]="value" (change)="checkChange($event)"></mat-checkbox>